import { FormsModule } from '@angular/forms';
import { NgForOf, NgIf, DecimalPipe } from '@angular/common';
import { MatIcon } from '@angular/material/icon';
import { Component, OnInit } from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { TabelaComponent } from '../../shared/tabela/tabela.component';
import { OnlyNumbersDirective } from '../../directives/only-numbers.directive';
import { SecaoDiagnosticoMatricula } from '../../utils/secao-diagnostico-matricula';
import { DiagnosticoMatriculaDto, TiposEtapasModalidadeSerieDto } from '../../dtos';
import { DiagnosticoMatriculaService, TiposEtapasModalidadeSerieService, EtapasDeEdicaoService } from '../../services/';
import { AnosReferenciasService } from '../../services/anos-referencias/anos-referencias.service';
import { AnosReferenciasDto } from '../../dtos/anos-referencias.dto';
import { FeatureFlagService } from '../../services/feature-flag/feature-flag.service';
import { EtapasEnsino } from '../../enums/etapas-ensino.enum';


@Component({
  selector: 'app-diagnostico-de-matricula',
  standalone: true,
  imports: [
    FormsModule,
    NgIf,
    TabelaComponent,
    DecimalPipe
  ],
  templateUrl: './diagnostico-de-matricula.component.html',
  styleUrl: './diagnostico-de-matricula.component.scss',
})
export class DiagnosticoDeMatriculaComponent implements OnInit {
  isLoading = false;
  public anosReferencias: AnosReferenciasDto | null = null;
  isCrechePorIdadeHabilitada = false;

  private mapaDiagnosticoPorEtapaId = new Map<number, DiagnosticoMatriculaDto>();

  diagnosticoMatricula: DiagnosticoMatriculaDto[] = [];

  secaoCreche: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoCrecheMenor1Ano: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoCreche1Ano: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoCreche2Anos: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoCreche3Anos: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoPreEscola: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoEnsinoFundamentalIniciais: SecaoDiagnosticoMatricula =
    new SecaoDiagnosticoMatricula();
  secaoEnsinoFundamentalFinais: SecaoDiagnosticoMatricula =
    new SecaoDiagnosticoMatricula();
  secaoEnsinoMedio: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();
  secaoEJA: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();

  total: SecaoDiagnosticoMatricula = new SecaoDiagnosticoMatricula();

  constructor(
    private etapasDeEdicaoService: EtapasDeEdicaoService,
    private diagnosticoMatriculaService: DiagnosticoMatriculaService,
    private anosReferenciasService: AnosReferenciasService,
    private featureFlagService: FeatureFlagService
  ) {
    if (this.featureFlagService.funcionalidadeHabilitada('938-migracao-datas-relatorios-1-e-2')) {
      this.anosReferencias = this.anosReferenciasService.obterAnosReferenciasSnapshot();
    }
    this.isCrechePorIdadeHabilitada = this.featureFlagService.funcionalidadeHabilitada('1104-creche-idade');
  }

  async ngOnInit(): Promise<void> {
    this.isLoading = true;

    this.etapasDeEdicaoService.setOpcaoAtual(1);

    this.diagnosticoMatricula =
      await this.diagnosticoMatriculaService.buscarListaDeDiagnosticoMatricula();

    this.mapaDiagnosticoPorEtapaId = new Map(
      this.diagnosticoMatricula.map(d => [d.idEtapaEnsino, d])
    );

    this.criarSecaoCreche();
    this.criarSecaoCrecheMenor1Ano();
    this.criarSecaoCreche1Ano();
    this.criarSecaoCreche2Anos();
    this.criarSecaoCreche3Anos();
    this.criarSecaoPreEscola();
    this.criarSecaoEnsinoFundamentalIniciais();
    this.criarSecaoEnsinoFundamentalFinais();
    this.criarSecaoEnsinoMedio();
    this.criarSecaoEJA();
    this.criarTotal();
  }

  private obterDiagnosticoDaEtapa(etapaId: number): DiagnosticoMatriculaDto | undefined {
    return this.mapaDiagnosticoPorEtapaId.get(etapaId);
  }

  criarSecaoCreche(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.CRECHE);
    if (diag) this.secaoCreche.addDiagnostico(diag);
  }

  criarSecaoCrecheMenor1Ano(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.CRECHE_MENOR_1_ANO);
    if (diag) this.secaoCrecheMenor1Ano.addDiagnostico(diag);
  }

  criarSecaoCreche1Ano(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.CRECHE_1_ANO);
    if (diag) this.secaoCreche1Ano.addDiagnostico(diag);
  }

  criarSecaoCreche2Anos(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.CRECHE_2_ANOS);
    if (diag) this.secaoCreche2Anos.addDiagnostico(diag);
  }

  criarSecaoCreche3Anos(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.CRECHE_3_ANOS);
    if (diag) this.secaoCreche3Anos.addDiagnostico(diag);
  }

  criarSecaoPreEscola(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.PRE_ESCOLA);
    if (diag) this.secaoPreEscola.addDiagnostico(diag);
  }

  criarSecaoEnsinoFundamentalIniciais(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.FUNDAMENTAL_INICIAIS);
    if (diag) this.secaoEnsinoFundamentalIniciais.addDiagnostico(diag);
  }

  criarSecaoEnsinoFundamentalFinais(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.FUNDAMENTAL_FINAIS);
    if (diag) this.secaoEnsinoFundamentalFinais.addDiagnostico(diag);
  }

  criarSecaoEnsinoMedio(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.MEDIO);
    if (diag) this.secaoEnsinoMedio.addDiagnostico(diag);
  }

  criarSecaoEJA(): void {
    const diag = this.obterDiagnosticoDaEtapa(EtapasEnsino.EJA);
    if (diag) this.secaoEJA.addDiagnostico(diag);
  }

  criarTotal(): void {
    const etapasDesagregadas = new Set([
      EtapasEnsino.CRECHE_MENOR_1_ANO,
      EtapasEnsino.CRECHE_1_ANO,
      EtapasEnsino.CRECHE_2_ANOS,
      EtapasEnsino.CRECHE_3_ANOS,
    ]);
    for (const [id, diag] of this.mapaDiagnosticoPorEtapaId.entries()) {
      if (!etapasDesagregadas.has(id)) {
        this.total.addDiagnostico(diag);
      }
    }
  }
}